export const SE360 = 1;
export const Scandphotos = 2;
export const Zentuvo = 3;

export function getOrderCssClass(site: number) {
    if (site === SE360) {
        return 'se360';
    }

    if (site === Zentuvo) {
        return 'se360';
    }

    if (site === Scandphotos) {
        return 'scandphotos';
    }

    return '';
}

export function getSiteName(site: number) {
    if (site === SE360) {
        return 'se360';
    }

    if (site === Zentuvo) {
        return 'zentuvo';
    }

    if (site === Scandphotos) {
        return 'scandphotos';
    }

    return '';
}
